import { Entity } from '@/store/shared/entity'
export default class Factory extends Entity<number>{
    name:string;
    shortName:string;
    domesticSourceOfGood:string;
    remark:string;
}